import type { SVGProps } from 'react'
import * as React from 'react'
const LogoutIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={33} height={32} fill='none' {...props}>
    <path
      fill='url(#a)'
      d='M14.31 9.549V22.45c0 .703 0 1.31.041 1.809.043.527.138 1.051.395 1.556a4 4 0 0 0 1.749 1.748c.504.257 1.028.352 1.555.395.5.041 1.106.041 1.81.041h3.569c.703 0 1.309 0 1.808-.04.527-.044 1.052-.139 1.556-.396a4 4 0 0 0 1.748-1.748c.257-.505.352-1.029.395-1.556.041-.5.041-1.106.041-1.809V9.55c0-.703 0-1.31-.04-1.809-.044-.527-.139-1.051-.396-1.556a4 4 0 0 0-1.748-1.748c-.504-.257-1.029-.352-1.556-.395C24.737 4 24.132 4 23.43 4h-3.57c-.703 0-1.31 0-1.809.04-.527.044-1.05.139-1.555.396a4 4 0 0 0-1.749 1.748c-.257.505-.352 1.029-.395 1.556-.04.5-.04 1.106-.04 1.809'
    />
    <g filter='url(#b)'>
      <path
        fill='#fff'
        fillOpacity={0.5}
        d='M11.253 19.058a1.333 1.333 0 1 1-1.886 1.885l-4-4a1.333 1.333 0 0 1 0-1.886l4-4a1.333 1.333 0 1 1 1.886 1.886l-1.724 1.724h11.448a1.333 1.333 0 0 1 0 2.667H9.529z'
      />
    </g>
    <defs>
      <linearGradient id='a' x1={14.31} x2={27.207} y1={4} y2={3.084} gradientUnits='userSpaceOnUse'>
        <stop stopColor='#ED8E98' />
        <stop offset={1} stopColor='#FF3347' />
      </linearGradient>
      <filter
        id='b'
        width={30.667}
        height={24}
        x={-1.69}
        y={4}
        colorInterpolationFilters='sRGB'
        filterUnits='userSpaceOnUse'
      >
        <feFlood floodOpacity={0} result='BackgroundImageFix' />
        <feGaussianBlur in='BackgroundImageFix' stdDeviation={3.333} />
        <feComposite in2='SourceAlpha' operator='in' result='effect1_backgroundBlur_1249_56295' />
        <feBlend in='SourceGraphic' in2='effect1_backgroundBlur_1249_56295' result='shape' />
        <feColorMatrix in='SourceAlpha' result='hardAlpha' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' />
        <feOffset dx={0.333} dy={0.167} />
        <feGaussianBlur stdDeviation={0.833} />
        <feComposite in2='hardAlpha' k2={-1} k3={1} operator='arithmetic' />
        <feColorMatrix values='0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0' />
        <feBlend in2='shape' result='effect2_innerShadow_1249_56295' />
      </filter>
    </defs>
  </svg>
)
export default LogoutIcon
